import { Component, OnInit, Input, ViewChild, TemplateRef ,Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as moment from 'moment';
import * as _ from 'lodash';

import { CashReceiptModel } from '../../../model/index';
import { AdvanceReturnService, SubscribeService } from '../../../services/index';

@Component({
    selector: 'cashreceipt-tab',
    templateUrl: './changeSerial.component.html',
})

export class ChangeSerialComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    @Output() itemUpdateEvent = new EventEmitter();

    public mode: string;
    public list: any[] = [];
    public cashreceipt: any[] = [];

    isLoadMask: Promise<any>;
    //cashreceipt: CashReceiptModel[]; 
    isLoading: boolean = false;
    getmodellist =[] ;

    constructor(private advanceReturnService: AdvanceReturnService, public subscribeService: SubscribeService, private modalService: BsModalService, public toasterService: ToasterService) {

        
    }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    filterData = {
        "search_name": "",
         bill_id : "",
         serial_no :"",
         model_id:""
    };

    getAutolist = [];
    @ViewChild('itemForm') itemForm;
    @ViewChild('emplistAutoComp') emplistAutoComp;

  
    ngOnInit(): void {
        this.getAutoNumberList();
        

    }

    
    displayFn(comboType: string, id: number) {
        let list: any[];
        if (comboType == "Party") {
            list = this.getAutolist
        }
        if (id && list.length > 0) {
            let fitem = _.find(list, { 'bill_id': id });
            return fitem['auto_no'];
        }
        return '';
    }
    display(comboType: string, id: number) {
        let list: any[];
        if (comboType == "Model") {
            list = this.getmodellist
        }
        if (id && list.length > 0) {
            let fitem = _.find(list, { 'model_id': id });
            return fitem['name'];
        }
        return '';
    }

    getAutoNumberList() {
        let that = this;
        that.advanceReturnService
            .getAdvanceNo({})
            .then((res: any) => {

                that.getAutolist = res.data;

            });
    }
    onSelectnumber(bill_id) {
        let that = this;
        let params ={
            bill_id: bill_id,
            
        }
        that.advanceReturnService
            .getModelname(params)
            .then((res: any) => {

                that.getmodellist = res.data;
            });
    
      
    }
    onChangemodel(model_id){
        let list = this.getmodellist;
        let modelList =  _.filter(list, { 'model_id': model_id });
        this.filterData.serial_no = modelList[0].serial_no;
       
      
    }

    onSaveSerial(){
        let params = {
            serial_no: this.filterData.serial_no,
            bill_id:this.filterData.bill_id,
            model_id: this.filterData.model_id,
        }
        let that = this;
        this.isLoading = true;
        // this.itemdata.company_id = this.companyInfo.id;
        this.advanceReturnService
            .addSerialno(params)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    //that.bsModalRef.hide();
                   /* that.branddata = {
                        "type": '',
                        "name": '',
                        "design_type": 'Fabric',
                    }*/

                    that.itemUpdateEvent.emit();
                    that.toasterService.pop({
                        bodyOutputType: 1,
                        type: 'success',
                        title: 'SUCCESS',
                        body: res.message
                    });
                    that.filterData.serial_no ='';
                    that.filterData.bill_id ='';
                    that.filterData.model_id ='';
                    $('#item_code').focus();
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/advanceReturn/changeSerial.component.ts